const ENV_OVERRIDE = (import.meta.env.VITE_PRODUCT_API_URL ?? import.meta.env.VITE_AZURE_FUNCTIONS_URL ?? import.meta.env.VITE_API_URL) as string | undefined;

export const API_HOST = ENV_OVERRIDE ?? '';

/** True when no product-specific API is configured (Hub-only mode). */
export const isApiAvailable = !!API_HOST;

export function buildApiUrl(path: string): string {
  if (path.startsWith('http')) return path;
  return `${API_HOST}${path}`;
}
